import { Analytics } from "@vercel/analytics/react";
import Layout from "./layout/Layout";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Router>
        {/* Website Layout Component Start */}
        <Layout />
        {/* Website Layout Component End */}
      </Router>
      {/* Vercel Analytics Component Start */}
      <Analytics />
      {/* Vercel Analytics Component End */}
    </div>
  );
}

export default App;
